import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { CUSTOM_MASK } from '@helpers/custom-validator';
import { INPUT_TYPES_MAP, InputTypeMap } from '@constants/input-types-map';
import { IErrorForm } from '@shared/form-wrapper/interfaces';
import { enumEntityModelCode } from '@data-layer/enums/entities';
import { CANADA_COUNTRY_CODE, MEXICO_COUNTRY_CODE, USA_COUNTRY_CODE } from '@constants/constants';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CountryModel } from '@data-layer/models/common';

@Component({
  selector: 'address-view-company',
  templateUrl: './address-view-company.component.html',
  styleUrls: ['./address-view-company.component.scss'],
})
export class AddressViewCompanyComponent implements OnInit, OnDestroy {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public code: enumEntityModelCode;
  @Input() public errors: { [name: string]: IErrorForm } = {};
  @Input() public isShowState: boolean = true;
  @Input() public isAllowCountryDisable: boolean = true;
  @Input() public isShowErrors: boolean = true;
  @Input() public isForeignCompany: boolean = true;
  @Input() public isFilterRestrictedCountries: boolean = false;
  @Input() public defaultCountry: any = null;
  @Input() public isFilterOnlyUSA: boolean;
  @Input() public isShowRequired: boolean;

  public integerInputMap: InputTypeMap = INPUT_TYPES_MAP.INTEGER;
  public addressFormGroup: UntypedFormGroup;
  public CUSTOM_MASK: any = CUSTOM_MASK;
  public isForeignCountry: boolean = false;

  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor() {}

  public ngOnInit(): void {
    this.addressFormGroup = this.formGroup.get('address') as UntypedFormGroup;
    const initialCountry = this.addressFormGroup.get('country').value;
    this.setStateForm(initialCountry);
    this.isForeignCountry = initialCountry?.code !== USA_COUNTRY_CODE;

    this.addressFormGroup
      .get('country')
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((val: CountryModel) => {
        // Only reset state if country actually changed to a different country
        if (val?.code !== this.addressFormGroup.get('state').value?.countryCode) {
          this.addressFormGroup.get('state').reset();
        }
        this.setStateForm(val);
        this.isForeignCountry = val?.code !== USA_COUNTRY_CODE;
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private setStateForm(val: CountryModel): void {
    if ([CANADA_COUNTRY_CODE, USA_COUNTRY_CODE, MEXICO_COUNTRY_CODE].includes(val?.code)) {
      if (!this.addressFormGroup.get('country').disabled) {
        this.addressFormGroup.get('state').enable();
      }
    } else {
      this.addressFormGroup.get('state').disable();
    }
  }
}
